/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { List } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

export const useNotificationMenuStyles = makeStyles(theme => ({
  paper: {
    margin: '7px 0',
    border: '1px solid #EEEEEE',
    borderRadius: '6px',
    position: 'relative',
    width: '312px',
  },
  expandedPaper: {
    maxHeight: '600px',
  },
  topActions: {
    position: 'sticky',
    top: 0,
    padding: '7px 7px 2px',
    backgroundColor: '#FFFFFF',
    zIndex: 1,
    borderBottom: '1px solid #EEEEEE',
    display: 'flex',
    justifyContent: 'space-between',
  },
  bottomActions: {
    position: 'sticky',
    bottom: 0,
    padding: '6px 15px',
    backgroundColor: '#FFFFFF',
    zIndex: 1,
    borderTop: '1px solid #EEEEEE',
    display: 'flex',
    justifyContent: 'space-between',
  },
  markAsReadBtn: {
    padding: 5,
    fontSize: '14px',
    lineHeight: '18px',
    color: theme.palette.primary.main,
    fontWeight: 500,
    borderRadius: '6px',
  },
  seeMoreBtn: {
    padding: 5,
    fontSize: '14px',
    lineHeight: '18px',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    borderRadius: '6px',
  },
  muteBtn: {
    padding: '5px',
    borderRadius: '6px',
    fontSize: '12px',
    lineHeight: '15px',
    '& svg': {
      marginRight: '5px',
    },
  },
  settingsBtn: {
    padding: '5px',
    borderRadius: '6px',
  },
  noItemsText: {
    fontSize: '14px',
    lineHeight: '18px',
    padding: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearAllBtn: {
    padding: '5px',
    borderRadius: '6px',
  },
  iconsGroup: {},
}));

export const StyledList = withStyles({
  padding: {
    padding: 0,
    paddingLeft: '16px',
  },
})(List);
